module.exports = __webpack_public_path__ + "img/22.fc7e6add.jpg";